import A from './components/A';
import B from './components/B';
import C from './components/C';
import Q from 'elem/compPage/Delta3Series/detail/comps/Q';

export default function TabRecycling() {
    return (
        <>
            <A />
            <B />
            <C />
            <Q />
        </>
    );
}
